// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3pBtS","label":"Category_label__3Rpjo","content":"Category_content__3cMip","header":"Category_header__2wpJR","location":"Category_location__2vo78"};